// extracted by mini-css-extract-plugin
module.exports = {"imageViewer":"ImageViewer_imageViewer__1tvsK","image":"ImageViewer_image__Ep4Tz"};